// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"ebeaf57f05916442317d","777":"9c3b3f9b4630c4a1e782"}[chunkId] + ".bundle.js";
};